function modifyBtnNavToggle() {
  const navToggle = document.querySelector('.mobile-nav-toggle');

  navToggle.innerHTML = `
    <span></span>
    <span></span>
    <span></span>
  `;
  navToggle.setAttribute('tabindex', '0');
  navToggle.setAttribute('role', 'button');
  navToggle.setAttribute('aria-label', 'open menu');
}

// create a function to add an img to each .button element

function modifyFeatureLineup() {
  $('.featureLineupContainer').each((i, element) => {
    const title = $(element).find('.featureLineup-title');
    const description = $(element).find('.featureLineup-text').eq(1);
    const img = $(element).find('.featureLineupImage');
    const subContainer = $(element).find('.subContainer:first-of-type');
    const moreBtn = $(element).find('.featureLineup-more a');
    const buyBtn = $(element).find('.featureLineup-buynow a');
    const descriptionText = description.text();
    const titleText = title.text().trim();
    const croppedTitle =
      titleText.length > 45 ? titleText.substring(0, 45) : titleText;

    const wrapper = `
    <div class="featureLineup-description">
      <h4 title="${titleText}" aria-label="${titleText}">${croppedTitle}</h4> <span>${descriptionText}</span>
    </div>
    `;
    const btnWrapper = $('<div class="featureLineup-cta"></div>');
    moreBtn.appendTo(btnWrapper);
    buyBtn.appendTo(btnWrapper);
    btnWrapper.appendTo(subContainer);
    img.append(wrapper);
    title.remove();
    description.remove();
  });
}

function modifySignUpForm() {
  const form = $('.emailSignup');
  form.find('.emailSignupText').text('Cluck Here For Updates!');
  form.find('.emailInputSubmit a').text('Subscribe');
  const input = form.find('.inputFieldTextbox.textbox');
  input.val('');
  input.attr('placeholder', 'Enter Email Address');
}

function modifySponsors() {
  const sponsorWidgetContainer = $('#sponsorWidgetContainer');
  const arrows = sponsorWidgetContainer.find('.sponsorArrow');
  const title = sponsorWidgetContainer.find('#sponsorsTitleContainer');
  title.prependTo('.sponsors-section');
  arrows.each((i, arrow) => {
    $(arrow)
      .find('span')
      .append(
        `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="15" viewBox="0 0 18 15">
          <path class="cls-1" d="M2396,996c0,0.4,9,8,9,8v-5h8s1.12-2.189,1-3a6.136,6.136,0,0,0-1-2h-8v-5S2396,995.6,2396,996Z" transform="translate(-2396 -989)"/>
        </svg>`
      );
  });
}
let menuTicketBtnModified = false;
function modifyMenuMobile() {
  $('.mobile-nav-toggle').on('click', () => {
    $('.mobile-menu-footer-links').css('opacity', '1');
    setTimeout(() => {
      if (!menuTicketBtnModified) {
        $('.mobile-menu-footer-links a').remove();
        // clone .header .ticket-btn into .mobile-menu-footer-links
        $('.header .ticket-btn').clone().appendTo('.mobile-menu-footer-links');
        // $('.header .ticket-btn').appendTo('.mobile-menu-footer-links');
        $('.mobile-menu-container').css('opacity', '1');
        menuTicketBtnModified = true;
      }
    }, 200);
  });
}

$(document).ready(() => {
  // Prepend General Message Banner to Header
  $('.generalmessage').prependTo('header');
  modifyBtnNavToggle();
  modifyFeatureLineup();

  if (window.location.pathname === '/') {
    modifySignUpForm();
    $(window).load(() => {
      setTimeout(() => {
        modifySponsors();
      }, 3000);
    });
  }
});

$(window).load(() => {
  // ---
  modifyMenuMobile();
});
$(window).resize(() => {});
